import { LocaleMessages, VueMessageType } from 'vue-i18n';
import { apiClient } from '@/api';

interface SupportedLocale {
  locale: string;
  lang: string;
  pattern: RegExp;
  messages: LocaleMessages<VueMessageType>;
}

export const supportedLocales: SupportedLocale[] = [
  {
    locale: 'en',
    lang: 'en-US',
    pattern: /^(en|en-.+)$/, // catchall for en-* & en
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    messages: {},
  },
  {
    locale: 'cn',
    lang: 'zh-CN',
    pattern: /^(zh|zh-.+)$/, // catchall for zh-* & zh
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    messages: {},
  },
  {
    locale: 'ja',
    lang: 'ja-JP',
    pattern: /^(ja|ja-.+)$/, // catchall for ja-* & ja
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    messages: {},
  },
];

export const DefaultLocale = 'en';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export async function fetchLocaleMessages(): Promise<Record<string, any>> {
  try {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const messages: Record<string, any> = {};
    await Promise.all(
      supportedLocales.map(async ({ locale, lang }) => {
        const response = await apiClient.getLangConfig(lang);
        if (!response) {
          console.error(`Failed to fetch messages for locale ${locale} lang=${lang}`);
        }
        messages[locale] = response;
      })
    );
    return messages;
  } catch (error) {
    return {};
  }
}
